import { jsx as _jsx } from "react/jsx-runtime";
import { FlexBox, IconButton, InputText } from '@dixa/lib-shared-habla';
import { useState } from 'react';
import { analytics } from 'app/utils/segment';
import { useAppNavigate } from 'utils/url/useAppNavigate';
import styles from './topBarSearchField.module.scss';
export const TopBarSearchField = ({ isOpen, onOpenChange, }) => {
    const [value, setValue] = useState('');
    const navigate = useAppNavigate();
    const handleOnSubmit = () => {
        if (value) {
            analytics.searchFieldSubmitted({
                location: 'topbar',
                isEmpty: false,
                query: value,
            });
            navigate({
                path: '/search/:tab',
                params: {
                    path: { tab: 'conversations' },
                    search: { q: value },
                },
            });
            onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(!isOpen);
        }
    };
    const resetSearchField = () => {
        setValue('');
        onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(false);
    };
    const handleOnKeyDown = (event) => {
        if (event.key === 'Enter') {
            handleOnSubmit();
        }
        if (event.key === 'Escape') {
            resetSearchField();
        }
    };
    if (!isOpen) {
        return null;
    }
    return (_jsx(InputText, { className: styles.root, type: "search", autoFocus: true, value: value, onChange: (e) => setValue(e.target.value), placeholder: "Search...", onFocus: () => analytics.searchFieldFocused({ location: 'topbar' }), onBlur: () => {
            analytics.searchFieldBlurred({ location: 'topbar' });
            resetSearchField();
        }, onKeyDown: (e) => handleOnKeyDown(e), "data-testid": "top-bar-search-input-field", suffix: {
            type: 'custom',
            value: (_jsx(FlexBox, Object.assign({ alignItems: "center", padding: "0 100", gap: "100" }, { children: _jsx(IconButton, { className: styles.inputButton, variant: "tertiary", size: "normal", icon: 'close', onClick: () => {
                        setValue('');
                        onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(!isOpen);
                    } }) }))),
            noWrap: true,
        } }));
};
